import manvarLogo from '../../../../assets/img/manvar-logo.png'

export const useHelpers = ({parseNumber}) => {

    const defaultFontSize = 10
    const titleFontSize = 25
    
    const getCurrentDate = () => {
        const today = new Date(); // Crea un objeto de fecha con la fecha actual
        const year = today.getFullYear(); // Obtiene el año
        const month = today.getMonth() + 1; // Obtiene el mes (getMonth() devuelve un índice basado en cero, por lo que se suma 1)
        const day = today.getDate(); // Obtiene el día del mes
    
        // Formatea la fecha en 'YYYY-MM-DD', asegurándote de agregar un cero delante de meses y días menores a 10
        return `${year}-${month < 10 ? `0${month}` : month}-${day < 10 ? `0${day}` : day}`;
    }

    const _drawHeaderPaymentLawyerTicket = (docPdf, data, posY) => {
        
        // Marco 
        docPdf.rect(10, 10, 260, 195); // x=10, y=20, ancho=100, alto=50

        // Logo
        const imgWidth = 50;
        const imgHeight = 30;
        docPdf.addImage(manvarLogo, 'PNG', 20, posY-15, imgWidth, imgHeight);

        // Membrete principal
        docPdf.setFont("helvetica", "bold");
        docPdf.setFontSize(titleFontSize);
        docPdf.text('INVERSIONES SOS S.A.', 140, posY, { align: 'center' }); // Centrado
        docPdf.setFontSize(defaultFontSize);

        posY += 5

        docPdf.setFont("helvetica", "normal");
        docPdf.text('KILÓMETRO 59.5 CARRETERA A TAXISCO, ESCUINTLA, ESCUINTLA', 140, posY, { align: 'center' });
        docPdf.text('TELEFONO: 2458-1568 EXTENSION 1', 140, posY+5, { align: 'center' });

        posY += 20
        
        // Fecha
        docPdf.setFillColor(230, 230, 230); // RGB gris
        docPdf.rect(20, posY, 35, 5, 'F');
        docPdf.rect(20, posY, 80, 5);
        docPdf.setFont("helvetica", "bold");
        docPdf.text('FECHA', 25, posY+4, { align: 'left' });
        docPdf.setFont("helvetica", "normal");
        docPdf.text(data.movimiento_fecha_recibo, 60, posY+4, { align: 'left' });
        
        // Hora
        docPdf.setFillColor(230, 230, 230); // RGB gris
        docPdf.rect(100, posY, 35, 5, 'F');
        docPdf.rect(100, posY, 80, 5);
        docPdf.setFont("helvetica", "bold");
        docPdf.text('HORA', 110, posY+4, { align: 'left' });
        docPdf.setFont("helvetica", "normal");
        docPdf.text(data.movimiento_hora_recibo, 140, posY+4, { align: 'left' });
        
        // Hora
        docPdf.setFillColor(230, 230, 230); // RGB gris
        docPdf.rect(180, posY, 35, 5, 'F');
        docPdf.rect(180, posY, 80, 5);
        docPdf.setFont("helvetica", "bold");
        docPdf.text('ESTADO', 185, posY+4, { align: 'left' });
        docPdf.setFont("helvetica", "normal");
        docPdf.text(data.aprobacion_check, 220, posY+4, { align: 'left' });

        posY += 10

        // Cliente
        docPdf.setFillColor(230, 230, 230); // RGB gris
        docPdf.rect(20, posY, 35, 5, 'F');
        docPdf.rect(20, posY, 160, 5); //240
        docPdf.setFont("helvetica", "bold");
        docPdf.text('CLIENTE', 25, posY+4, { align: 'left' });
        docPdf.setFont("helvetica", "normal");
        docPdf.text(data.info_cliente, 58, posY+4, { align: 'left' });
        
        // Por
        docPdf.setFillColor(230, 230, 230); // RGB gris
        docPdf.rect(180, posY, 35, 5, 'F');
        docPdf.rect(180, posY, 80, 5);
        docPdf.setFont("helvetica", "bold");
        docPdf.text('POR', 185, posY+4, { align: 'left' });
        docPdf.setFont("helvetica", "normal");
        docPdf.text('Q. ' + parseFloat(data.movimiento_quetzales).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }), 220, posY+4, { align: 'left' });
        
        posY += 5

        // Concepto
        docPdf.setFillColor(230, 230, 230); // RGB gris
        docPdf.rect(20, posY, 35, 5, 'F');
        docPdf.rect(20, posY, 160, 5);
        docPdf.setFont("helvetica", "bold");
        docPdf.text('CONCEPTO', 25, posY+4, { align: 'left' });
        docPdf.setFont("helvetica", "normal");
        docPdf.text(`SERVICIOS DE ABOGACÍA Y NOTARIADO ${data.process_number}`, 58, posY+4, { align: 'left' });
        
        // Fecha de pago
        docPdf.setFillColor(230, 230, 230); // RGB gris
        docPdf.rect(180, posY, 35, 5, 'F');
        docPdf.rect(180, posY, 80, 5);
        docPdf.setFont("helvetica", "bold");
        docPdf.text('F. PAGO', 185, posY+4, { align: 'left' });
        docPdf.setFont("helvetica", "normal");
        // docPdf.text(data.mes_a_pagar, 220, posY+4, { align: 'left' });

    }

    const _drawIdentifiersPaymentLawyerTicket = (docPdf, data, posY) => {

        docPdf.setFont("helvetica", "bold");
        docPdf.setFontSize(defaultFontSize);
        docPdf.text(`PROCESO ${data.process_number}`, 215, posY);
        docPdf.text(`RECIBO NO. ${data.idtransaction}`, 215, posY+5);

    }

    const _drawInfoPaymentLawyerTicket = (docPdf, data, posY) => {

        // Info Pago
        docPdf.setFillColor(230, 230, 230); // RGB gris
        docPdf.rect(20, posY, 23, 5, 'F');
        docPdf.rect(20, posY, 47, 5);
        docPdf.setFont("helvetica", "bold");
        docPdf.text('TIPO', 23, posY+4, { align: 'left' });
        docPdf.setFont("helvetica", "normal");
        docPdf.text(data.movimiento_tipo, 45, posY+4, { align: 'left' });

        // Monto
        docPdf.setFillColor(230, 230, 230); // RGB gris
        docPdf.rect(67, posY, 23, 5, 'F');
        docPdf.rect(67, posY, 47, 5);
        docPdf.setFont("helvetica", "bold");
        docPdf.text('MONTO', 70, posY+4, { align: 'left' });
        docPdf.setFont("helvetica", "normal");
        docPdf.text(parseFloat(data.movimiento_monto).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }), 92, posY+4, { align: 'left' });

        posY += 5

        // Moneda
        docPdf.setFillColor(230, 230, 230); // RGB gris
        docPdf.rect(20, posY, 23, 5, 'F');
        docPdf.rect(20, posY, 47, 5);
        docPdf.setFont("helvetica", "bold");
        docPdf.text('MONEDA', 23, posY+4, { align: 'left' });
        docPdf.setFont("helvetica", "normal");
        docPdf.text(data.movimiento_moneda, 45, posY+4, { align: 'left' });

        // Tipo cambio
        docPdf.setFillColor(230, 230, 230); // RGB gris
        docPdf.rect(67, posY, 23, 5, 'F');
        docPdf.rect(67, posY, 47, 5);
        docPdf.setFont("helvetica", "bold");
        docPdf.text('CAMBIO', 70, posY+4, { align: 'left' });
        docPdf.setFont("helvetica", "normal");
        docPdf.text(parseFloat(data.movimiento_tipo_cambio).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }), 92, posY+4, { align: 'left' });
        
        posY += 5

        // Total Queztales
        docPdf.setFillColor(230, 230, 230); // RGB gris
        docPdf.rect(20, posY, 23, 5, 'F');
        docPdf.rect(20, posY, 47, 5);
        docPdf.setFont("helvetica", "bold");
        docPdf.text('TOTAL Q.', 23, posY+4, { align: 'left' });
        docPdf.setFont("helvetica", "normal");
        docPdf.text(parseFloat(data.movimiento_quetzales).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }), 45, posY+4, { align: 'left' });

        // Total Dolares
        docPdf.setFillColor(230, 230, 230); // RGB gris
        docPdf.rect(67, posY, 23, 5, 'F');
        docPdf.rect(67, posY, 47, 5);
        docPdf.setFont("helvetica", "bold");
        docPdf.text('TOTAL $.', 70, posY+4, { align: 'left' });
        docPdf.setFont("helvetica", "normal");
        docPdf.text(parseFloat(data.movimiento_dolares).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }), 92, posY+4, { align: 'left' });
        
        posY += 10

        // Cuenta
        docPdf.setFillColor(230, 230, 230); // RGB gris
        docPdf.rect(20, posY, 23, 5, 'F');
        docPdf.rect(20, posY, 94, 5);
        docPdf.setFont("helvetica", "bold");
        docPdf.text('CAJA', 23, posY+4, { align: 'left' });
        docPdf.setFont("helvetica", "normal");
        docPdf.text(data.descripcion_caja || '---', 45, posY+4, { align: 'left' });

        posY += 5

        // Cuenta
        docPdf.setFillColor(230, 230, 230); // RGB gris
        docPdf.rect(20, posY, 23, 5, 'F');
        docPdf.rect(20, posY, 94, 5);
        docPdf.setFont("helvetica", "bold");
        docPdf.text('BANCO', 23, posY+4, { align: 'left' });
        docPdf.setFont("helvetica", "normal");
        docPdf.text(data.descripcion_banco || '---', 45, posY+4, { align: 'left' });
        
        posY += 5

        // Numero de boleta
        docPdf.setFillColor(230, 230, 230); // RGB gris
        docPdf.rect(20, posY, 23, 5, 'F');
        docPdf.rect(20, posY, 47, 5);
        docPdf.setFont("helvetica", "bold");
        docPdf.text('BOLETA', 23, posY+4, { align: 'left' });
        docPdf.setFont("helvetica", "normal");
        docPdf.text(data.boleta_numero || '---', 45, posY+4, { align: 'left' });

        // Referencia ACH
        docPdf.setFillColor(230, 230, 230); // RGB gris
        docPdf.rect(67, posY, 23, 5, 'F');
        docPdf.rect(67, posY, 47, 5);
        docPdf.setFont("helvetica", "bold");
        docPdf.text('ACH', 70, posY+4, { align: 'left' });
        docPdf.setFont("helvetica", "normal");
        docPdf.text(data.aprobacion_referencia_ach || '---', 92, posY+4, { align: 'left' });
    }

    const _drawBalanceInfoPaymentLawyerTicket = (docPdf, data, posY) => {
        
        // console.log('_drawBalanceInfoPaymentLawyerTicket', data)

        // Alquiler
        docPdf.setFillColor(230, 230, 230); // RGB gris
        docPdf.rect(123, posY, 23, 5, 'F');
        docPdf.rect(123, posY, 47, 5);
        docPdf.setFont("helvetica", "bold");
        docPdf.text('COSTO', 126, posY+4, { align: 'left' });
        docPdf.setFont("helvetica", "normal");
        docPdf.text('Q ' + parseFloat(data.initial_amount).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }), 148, posY+4, { align: 'left' });

        posY += 5

        // Otros Gastos
        docPdf.setFillColor(230, 230, 230); // RGB gris
        docPdf.rect(123, posY, 23, 5, 'F');
        docPdf.rect(123, posY, 47, 5);
        docPdf.setFont("helvetica", "bold");
        docPdf.text('GASTOS', 126, posY+4, { align: 'left' });
        docPdf.setFont("helvetica", "normal");
        docPdf.text('Q ' + parseFloat(data.other_expense_total).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }), 148, posY+4, { align: 'left' });
        
        posY += 5

        // Total a pagar
        docPdf.setFillColor(230, 230, 230); // RGB gris
        docPdf.rect(123, posY, 23, 5, 'F');
        docPdf.rect(123, posY, 47, 5);
        docPdf.setFont("helvetica", "bold");
        docPdf.text('TOTAL', 126, posY+4, { align: 'left' });
        docPdf.setFont("helvetica", "normal");
        docPdf.text('Q ' + parseFloat(data.total_pagar).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }), 148, posY+4, { align: 'left' });

        posY += 5

        // Descuentos
        docPdf.setFillColor(230, 230, 230); // RGB gris
        docPdf.rect(123, posY, 23, 5, 'F');
        docPdf.rect(123, posY, 47, 5);
        docPdf.setFont("helvetica", "bold");
        docPdf.text('DESCUEN.', 126, posY+4, { align: 'left' });
        docPdf.setFont("helvetica", "normal");
        docPdf.text('Q ' + parseFloat(data.total_discount).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }), 148, posY+4, { align: 'left' });
        
        posY += 5

        // Recibido
        docPdf.setFillColor(230, 230, 230); // RGB gris
        docPdf.rect(123, posY, 23, 5, 'F');
        docPdf.rect(123, posY, 47, 5);
        docPdf.setFont("helvetica", "bold");
        docPdf.text('RECIBIDO', 126, posY+4, { align: 'left' });
        docPdf.setFont("helvetica", "normal");
        docPdf.text('Q ' + parseFloat(data.total_recibido).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }), 148, posY+4, { align: 'left' });
        
        posY += 5

        // Saldo
        docPdf.setFillColor(230, 230, 230); // RGB gris
        docPdf.rect(123, posY, 23, 5, 'F');
        docPdf.rect(123, posY, 47, 5);
        docPdf.setFont("helvetica", "bold");
        docPdf.text('SALDO', 126, posY+4, { align: 'left' });
        docPdf.setFont("helvetica", "normal");
        docPdf.text('Q ' + parseFloat(data.saldo_total).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }), 148, posY+4, { align: 'left' });

    }

    const _drawObservationsPaymentLawyerTicket = (docPdf, data, justifyTextBox, posY) => {

        // Info Pago
        docPdf.setFillColor(230, 230, 230); // RGB gris
        // docPdf.rect(20, posY, 35, 5, 'F');
        docPdf.rect(180, posY, 80, 70);
        docPdf.setFont("helvetica", "bold");
        docPdf.text('OBSERVACIONES', 183, posY+4, { align: 'left' });
        
        posY += 5
        docPdf.setFont("helvetica", "normal");
        justifyTextBox(docPdf, data.movimiento_observaciones || '', 181, posY+4, 90, {
            fontSize: defaultFontSize,
            fontName: 'helvetica',
            lineSpacing: 5
        })

        posY += 35
        docPdf.setFont("helvetica", "normal");
        justifyTextBox(docPdf, data.aprobacion_observaciones || '', 181, posY+4, 90, {
            fontSize: defaultFontSize,
            fontName: 'helvetica',
            lineSpacing: 5
        })

    }

    const _drawFooterPaymentLawyerTicket = (docPdf, data, justifyTextBox, posY) => {
        
        docPdf.line(20, posY, 90, posY);
        docPdf.text('FIRMA AUTORIZADA', 40, posY+7, { align: 'left' });
        docPdf.text('SELLO', 125, posY+4, { align: 'left' });

        // posY += 20
        // docPdf.setFont("helvetica", "normal");
        // const text = '*NOTA:* Por cheque rechazado se cobrará en concepto de gastos administrativos: Q150.00 cheques en Quetzales y $20.00 cheques en dólares, quedando anulado este recibo de inmediato. INTERESES Y MORA: Se cobrará 10% sobre la cuota a vigente a cancelar y un monto de Q10.00 diarios en concepto de mora, hasta hacer efectivo el pago correspondiente, este monto podrá variar conforme al contrato vigente o conforme a políticas internas sin previo aviso. Plazo Extemporáneo: Se cobrará Q1,000.00 por me adicional después de vencido el plazo contractual o estipulado por cada negocio.'
        // justifyTextBox(docPdf, text, 20, posY, 240, {
        //     fontSize: defaultFontSize,
        //     fontName: 'helvetica',
        //     lineSpacing: 5
        // })
    }
    
    const _drawExpensesLawyerTicket = (docPdf, data, posY) => {
        
        for(let i = 0; i<data.infoExpenses.length; i++){
            // Saldo
            docPdf.setFillColor(230, 230, 230); // RGB gris
            docPdf.rect(123, posY, 23, 5, 'F');
            docPdf.rect(123, posY, 47, 5);
            docPdf.setFont("helvetica", "bold");
            docPdf.text(`${data.infoExpenses[i].expense_description}`, 126, posY+4, { align: 'left' });
            docPdf.setFont("helvetica", "normal");
            docPdf.text(String(data.infoExpenses[i].costo), 148, posY+4, { align: 'left' });

            posY += 5
        }

        
    }

    const drawPaymentLawyerTicket = (pdfManager, data) => {
        
        const { pdfLandscapeDoc, justifyTextBox } = pdfManager

        // console.log('drawPaymentLawyerTicket ----- ', data)

        _drawHeaderPaymentLawyerTicket(pdfLandscapeDoc, data, 30)
        _drawIdentifiersPaymentLawyerTicket(pdfLandscapeDoc, data, 30)
        _drawInfoPaymentLawyerTicket(pdfLandscapeDoc, data, 90)
        _drawBalanceInfoPaymentLawyerTicket(pdfLandscapeDoc, data, 90)
        _drawObservationsPaymentLawyerTicket(pdfLandscapeDoc, data, justifyTextBox, 90)
        _drawFooterPaymentLawyerTicket(pdfLandscapeDoc, data, justifyTextBox, 185)
        // _drawExpensesLawyerTicket(pdfLandscapeDoc, data, 130)

        pdfLandscapeDoc.save(`RECIBO PREDIO ${data.process_number}.pdf`);
    }
    
    return Object.freeze({
        getCurrentDate,
        drawPaymentLawyerTicket
    })
}